<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Etkinlik Başvuru Listesi - {{ event.name }}
            </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-actions">
                <!-- <a routerLink="/event-property-list/new/{{eventId}}" class="btn btn-success btn-pill btn-sm">
                    <i class="fa fa-plus marr10"></i>Yeni Ekle
                </a> -->
                <a routerLink="/event-list" class="btn btn-primary btn-pill btn-sm">
                    <i class="fa fa-left-arrow marr10"></i>Geri Dön
                </a>
            </div>
        </div>
        
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="fullName" class="col-12 col-form-label">Ad soyad</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="fullName" name="fullName"
                                [(ngModel)]="filters.fullName" placeholder="Ad soyad">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="email" class="col-12 col-form-label">Email</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="email" name="email"
                                [(ngModel)]="filters.email" placeholder="Email">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="role" class="col-12 col-form-label">Rol</label>
                        <div class="col-12">
                            <input class="form-control" type="text" id="role" name="role"
                                [(ngModel)]="filters.role" placeholder="Rol">
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="startDate" class="col-12 col-form-label">Başvuru tarihi başlangıç</label>
                        <div class="col-12">
                            <input class="form-control" type="date" [(ngModel)]="filters.startDate" id="startDate"
                                 name="startDate">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="endDate" class="col-12 col-form-label">Başvuru tarihi bitiş</label>
                        <div class="col-12">
                            <input class="form-control" type="date" [(ngModel)]="filters.endDate" id="endDate"
                                name="endDate">
                        </div>
                    </div>
                    <div class="col-4">
                        <label for="status" class="col-12 col-form-label">Başvuru durumu</label>
                        <div class="col-12">
                            <ng-select name="type" id="status" labelForId="status" bindValue="code"
                                [items]="applicationStatusTypes" bindLabel="text" [(ngModel)]="filters.status"
                                placeholder="Seçiniz..">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-4">
                        <label for="status" class="col-12 col-form-label">En son gönderilen email</label>
                        <div class="col-12">
                            <ng-select name="type" id="lastSentEmail" labelForId="lastSentEmail" bindValue="code"
                                [items]="applicationEmailStatusTypes" bindLabel="text" [(ngModel)]="filters.lastSentEmail"
                                placeholder="Seçiniz..">
                            </ng-select>
                        </div>
                    </div>
                </div>
                
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label for="endDate" class="col-12 col-form-label">&nbsp;</label>
                        <div class="col-12">
                            <button class="btn btn-outline-success" (click)="filterResults()">Filtrele</button>
                            <button class="btn btn-outline-danger ml-3" (click)="resetFilters()">Sıfırla</button>
                            <button class="btn btn-outline-dark ml-3" (click)="excelExport()">Excel oluştur</button>
                            <a href="{{assetsPath + excelPath}}" target="_blank" class="btn btn-outline-success ml-3" *ngIf="excelPath">Excel indir</a>                            
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <button class="btn btn-outline-success ml-2" (click)="updateStatus('onayla')">Onayla</button>
                        <button class="btn btn-outline-danger ml-3" (click)="updateStatus('reddet')">Reddet</button>
                        <button class="btn btn-outline-primary ml-3" (click)="updateStatus('tamamla')">Tamamla</button>
                        <button class="btn btn-outline-dark ml-3" (click)="updateStatus('bekleme')">Bekleme listesine al</button>
                        <button class="btn btn-outline-warning ml-3" (click)="updateStatus('katilmadi')">Katılmadı</button>
                        <button class="btn btn-danger ml-3" (click)="updateStatus('sil')">Sil</button>
                    </div>
                </div>
                <div class="row justify-content-end">
                    <button type="button" class="pagination-button" (click)="setFirstPage()"><<</button>
                    <button type="button" class="pagination-button" (click)="decrementPage()"><</button>
                    <!-- <button type="button" class="pagination-button active">1</button>
                    <button type="button" class="pagination-button">2</button>
                    <button type="button" class="pagination-button">3</button>
                    <button type="button" class="pagination-button">4</button> -->
                    <span class="pagination-text">{{currentPageNum*rowPerPage + 1}}-{{(currentPageNum+1)*rowPerPage}} of {{eventApplications.length}}</span>
                    <button type="button" class="pagination-button" (click)="incrementPage()">></button>
                    <button type="button" class="pagination-button" (click)="setLastPage()">>></button>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Ad soyad</th>
                                <th>Email</th>
                                <th>Rol</th>
                                <th>Başvuru tarihi</th>
                                <th>Durum</th>
                                <th>En son gönderilen email</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eventApplication of tableCardList;">
                                <td><input class="form-control" (change)="onChange(eventApplication.id, $event.target.checked)" name="{{ eventApplication.id }}" type="checkbox" id="{{eventApplication.id}}"></td>
                                <td><a [routerLink]="['/view-profile/'+eventApplication.userId]">{{eventApplication.displayName}}</a></td>
                                <td>{{eventApplication.email}}</td>
                                <td>{{eventApplication.roleName}}</td>
                                <td>{{eventApplication.applicationDate}}</td>
                                <td>{{getApplicationStatus(eventApplication.status)}}</td>
                                <td>{{getApplicationEmailStatus(eventApplication.lastSentEmail)}}</td>
                                <td>
                                    <button type="button" class="btn btn-success" (click)="sendEmail(eventApplication.id)">Mail gönder</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row justify-content-end">
                    <button type="button" class="pagination-button" (click)="setFirstPage()"><<</button>
                    <button type="button" class="pagination-button" (click)="decrementPage()"><</button>
                    <!-- <button type="button" class="pagination-button active">1</button>
                    <button type="button" class="pagination-button">2</button>
                    <button type="button" class="pagination-button">3</button>
                    <button type="button" class="pagination-button">4</button> -->
                    <span class="pagination-text">{{currentPageNum*rowPerPage + 1}}-{{(currentPageNum+1)*rowPerPage}} of {{eventApplications.length}}</span>
                    <button type="button" class="pagination-button" (click)="incrementPage()">></button>
                    <button type="button" class="pagination-button" (click)="setLastPage()">>></button>
                </div>
            </div>
        </div>
    </div>
</div>
